/* eslint-disable no-empty-pattern */
import Vue from 'vue'
import Vuex from 'vuex'
import AppSettings from '../settings.js'

Vue.use(Vuex)

import Appointments from './modules/appointments.store'
import Files from './modules/files.store'
import Prescriptions from './modules/prescriptions.store'
import Users from './modules/users.store'
import Patients from './modules/patients.store'
import Endpoints from './modules/endpoints.store'
import Webex from './modules/webex.store.js'
import NurseCalling from './modules/nursecalling.store'
import LabOrders from './modules/laborders.store'
import CreditRequest from './modules/credits.store'
import Ambulance from './modules/ambulance.store'
import CreditsEarning from './modules/creditsearning.store'
import Healthcheckup from './modules/healthcheckup.store'
import FitnessStore from './modules/fitness.store.js'
import IcuStore from './modules/icu.store.js'
import AndroidGateway from './modules/androidgateway.store.js'
import ForumStore from './modules/forum.store.js'

export default new Vuex.Store({
  modules: {
    Appointments,
    Endpoints,
    Files,
    NurseCalling,
    LabOrders,
    Patients,
    Prescriptions,
    Users,
    Webex,
    CreditRequest,
    Ambulance,
    CreditsEarning,
    Healthcheckup,
    FitnessStore,
    IcuStore,
    AndroidGateway,
    ForumStore
  },
  state: {
    deviceProfile: [],
    baseUrl: localStorage.baseUrl || AppSettings.url,
    locale: localStorage.locale || AppSettings.defaultLocale,
    appSettings: AppSettings,
    prescriptions: null,
    caregroup: null,
    questionnaires: null,
    messages: null,
    chatThread: [],
    settings: null,
    appointment: null,
    appointments: null,
    deviceToScan: null,
    doctorList: [],
    scheduledAppointments: [],
    files: [],
    vitalErrorMessages: {},
    myLocation: null,
    homePageActiveTab: null,
    patient: null,
    endpoint: null,
    icuEndpoint: null,
    icuAppointment: null,
    patientId: null,
    userDetails: null,
    appBackgroundUrl: null,
    brandLogoMini: null,
    FCMpayload: null,
    SHOW_OTP_MODAL: false,
    connectedDevices: AppSettings.connectedDevices,
    locationTracking: AppSettings.locationTracking,
    paymentGateway: AppSettings.paymentGateway,
    appHeaderText: null,
    scannedDevices: [],
    OFFLINE: false,
    recordingsUrl: "",
    shouldChangePasswordUser: {},
    ambulanceRequest: null,
    bookingReq: null,
    scheduledRequest: null,
    selectedLocation: null,
    selectedEndpoint: null,
    deviceToAddVital: [],
    errorMessages: {},

    //Webex Embedded
    webexEmbeddedConfig: {
      inAppBrowserRef: null,
      webexOAuth2BaseUrl: "https://api.ciscospark.com/v1/authorize",
      webexIdBrokerUri1: "https://idbroker.webex.com/idb/saml2/jsp/doSSO.jsp",
      webexIdBrokerUri2: "https://idbroker.webex.com/idb/globalLogin",
      webexIdBrokerUri3: "https://idbroker.webex.com/idb/oauth2/oauth2Consent.jsp",
      webexAccessTokenUrl: "https://api.ciscospark.com/v1/access_token",
      redirectUri: "https://teslon.io/authcallback",
    },
    Webex: null,

    selectedAhcAppointment: null,
    healthPackages: null,
    obd2Data: {},
    checkupRequests: [],
    videos: [],

    //Wellness
    training: null,
    trainingType: "",
    currentTrainingDayIndex: null,
    exercisesForCurrentDay: [],
    blogArticle: null,
    recipe: null,
    latestPrescription: null,
    launchedByClickingOnLocalNotification: null,
    selectedPrescription: false,
    erEncounter: null,
    fitnessOrYogaReport: null,
    selectedMedicalDevice: null,
    selectedDeviceProfile: null,
    vitalToAdd: null,
    vitalsHelp: null,
    vitalsToAdd: [],
    vitalGroupIdentifier: "",
    tabsRenderCount: 0,
    latestERStatusQuery: "",
    icuLocation: null,
    NutritionConsultation: false,

    // blogFeed is an object containing {blogArticles, blogArticlesPagination} fields
    blogFeed: null,
    // forumPosts is an object containing {formPosts, formPostPagination} fields
    forumPosts: null,

    forumPostCache: {},
    postRouteStack: [],
  },

  getters: {
    getVitalImage: (state) => (vitalIdentifier) => {
      return state.vitalProfile.filter((profile) => {
        return profile.identifier == vitalIdentifier
      })[0].imagePath
    },
  },

  mutations: {
    setState(state, data) {
      state[data.stateName] = data.stateValue
    }
  },

  actions: {

    async validateUrl({ state }, url) {
      try {
        //added timeout of 10000ms because spelling mistake in url takes too long to give response sometimes
        let val = (await Vue.http.get(url, { timeout: 10000 }))
        return val
      } catch (error) {
        throw error
      }
    },

    //Authentication and authorization actions
    async signin({ state }, credentials) {
      try {
        let user = (await Vue.http.post(state.baseUrl + '/auth/signin', credentials)).data

        try {
          let response = (await Vue.http.get(state.baseUrl + '/endpoints/bydevicetype/' + user._id + '?deviceType=Android')).data
          console.log('user endpoint - ', response)
          if (response && response._id) {
            user.endpoint = response
          }
          return user
        } catch (e) {
          console.log(e)
          return user
        }

      } catch (e) {
        console.log(e)
        throw e
      }
    },
    async termsOfUse({ state }) {
      try {
        return (await Vue.http.get(state.baseUrl + '/configurations/termsAndConditionText')).data
      } catch (e) {
        console.log(e)
        throw e.response.data
      }
    },
    async privacyPolicy({ state }) {
      try {
        return (await Vue.http.get(state.baseUrl + '/configurations/privacyPolicyText')).data
      } catch (e) {
        console.log(e)
        throw e.response.data
      }
    },
    async changePassword({ state }, passwordDetails) {
      try {
        return (await Vue.http.post(state.baseUrl + '/users/password', passwordDetails)).data
      } catch (e) {
        console.log(e)
        throw e.response.data
      }
    },
    async shouldChangePassword({ state }, options) {
      try {
        return (await Vue.http.post(state.baseUrl + '/users/changepassword', options)).data
      } catch (e) {
        console.log(e)
        throw e.response.data
      }
    },
    async resetPassword({ state }, passwordDetails) {
      try {
        return (await Vue.http.post(state.baseUrl + '/auth/forgot', passwordDetails)).data
      } catch (e) {
        console.log(e)
        throw e.response.data
      }
    },
    async generateOtp({ state }, options) {
      try {
        return (await Vue.http.post(state.baseUrl + '/auth/otp/_generate', options))
      } catch (e) {
        console.log(e)
        return e.message ? e.message : null
      }
    },
    async validateOtp({ state }, options) {
      try {
        let response = await Vue.http.post(state.baseUrl + '/auth/signin/otp', options)

        if (response && response.data) {
          try {
            let res = (await Vue.http.get(state.baseUrl + '/endpoints/bydevicetype/' + response.data._id + '?deviceType=Android')).data
            console.log('user endpoint - ', res)
            if (res && res._id) {
              response.data.endpoint = res;
            }
            console.log("otp user - ", response.data);
            return response.data
          } catch (e) {
            return response.data
          }
        }
        else {
          return null
        }
      } catch (e) {
        console.log(e)
        return null
      }
    },

    //Common actions
    async searchDoctors({ state }, options) {
      let queryArr = []
      if (options.gender) {
        queryArr.push('gender=' + options.gender)
      }
      if (options.availableFor) {
        queryArr.push('availableFor=' + options.availableFor)
      }
      if (options.location) {
        queryArr.push('location=' + options.location)
      }
      if (options.speciality) {
        queryArr.push('speciality=' + options.speciality)
      }
      let query = queryArr.join('&')
      return (await Vue.http.get(state.baseUrl + '/providers/search/' + options.searchString + '?' + query)).data
    },
    async searchOnlineDoctors({ state }, searchString) {
      return (await Vue.http.get(state.baseUrl + '/providers/search/_online/' + searchString)).data
    },
    async getOnlineDoctors({ state }, options) {
      let queryArr = []
      if (options) {
        if (options.gender) {
          queryArr.push('gender=' + options.gender)
        }
        if (options.availableFor) {
          queryArr.push('availableFor=' + options.availableFor)
        }

        if (options.location) {
          queryArr.push('location=' + options.location)
        }
        if (options.speciality) {
          queryArr.push('speciality=' + options.speciality)
        }
      }

      let query = queryArr.join('&')
      return (await Vue.http.get(state.baseUrl + '/providers/online' + '?' + query))
    },
    async getProviderQuestionnaires({ state }, providerId) {
      return (await Vue.http.get(state.baseUrl + '/questionnaires/byProvider/' + providerId)).data
    },
    async getAvailableSlots({ state }, query) {
      return (await Vue.http.post(state.baseUrl + '/slots/query', query)).data
    },
    async searchSpecialities({ state }, searchString) {
      return (await Vue.http.get(state.baseUrl + '/specialities/search/' + searchString)).data || []
    },
    async getVitals({ state }) {
      return (await Vue.http.get(state.baseUrl + '/vitals/')).data || []
    },
    async saveVitalsData({ state }, vitals) {
      return (await Vue.http
        .post(state.baseUrl + "/vitalsdata", vitals)
      )
    },

    async getCaregroup({ commit, state }, caregroupId) {
      try {
        let caregroup = (await Vue.http.get(state.baseUrl + '/caregroups/' + caregroupId)).data
        commit('setState', { stateName: 'caregroup', stateValue: caregroup })
        return caregroup
      } catch (e) {
        console.log(e)
      }
    },
    async getCaregroups({ commit, state }) {
      try {
        let caregroups = (await Vue.http.get(state.baseUrl + '/caregroups/')).data
        return caregroups
      } catch (e) {
        console.log(e)
      }
    },
    async saveQuestionnaireAnswers({ state }, data) {
      try {
        return (await Vue.http.post(state.baseUrl + '/questionnaireanswers', data)).data
      } catch (e) {
        console.log(e)
      }
    },
    async getQuestionnaireAnswers({ state }, options) {
      try {
        return (await Vue.http.post(state.baseUrl + '/questionnaireanswers/_filter?pageSize=' + (options.pageSize || '8') + '&pageNumber=' + options.pageNumber, {
          patientId: options.patientId
        })).data
      } catch (e) {
        console.log(e)
      }
    },
    async getAnsweredQuestionnaire({ state }, questionnaireAnswerId) {
      return (await Vue.http.get(state.baseUrl + '/questionnaireanswers/' + questionnaireAnswerId)).data
    },
    async getSpecialities({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/specialities/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
    },

    async getSettings({ commit, state, dispatch }) {
      let settings
      try {
        settings = (await Vue.http.get(state.baseUrl + '/appsettings')).data || null
        commit('setState', { stateName: 'settings', stateValue: settings })

        //Setting UC Service globally for simple meetings in app config
        if (settings.vMaatuSettings) {
          if (settings.vMaatuSettings.ucServiceBaseUrl) {
            const config = {
              "UC_SERVER_URL": settings.vMaatuSettings.ucServiceSocketUrl,
              "UC_SERVER_API_USERNAME": settings.vMaatuSettings.ucServiceUsername || '',
              "UC_SERVER_API_PASSWORD": settings.vMaatuSettings.ucServicePassword || ''
            };
            window.config = config;
          }
        }

        let tenant = await dispatch('getTenantName')
        let brandLogoMini = await dispatch('getBrandLogoMini', tenant)
      } catch (e) {
        console.log(e)
      }
      return settings
    },

    async getConfigurationByType({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/configurations/' + options.type)).data
    },
    async getConfigurationByEndpointId({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/configurations/' + options.type + '?endpointId=' + options.endpointId)).data
    },
    async getPublicConfigurationByType({ state }, options) {
      let tenant = options.tenant || "default";
      return (await Vue.http.get(state.baseUrl + '/directtelemedicine/configurations/' + options.type, {
        headers: {
          'tenant': tenant
        }
      })).data
    },

    async getTenantName({ state }) {

      console.log('base url', state.baseUrl)
      let domains = (await Vue.http.get(state.baseUrl + "/tenants/domains")).data;
      let tenant = "default";
      console.log('the ', domains[state.baseUrl.split('/')[2]])
      if (domains[state.baseUrl.split('/')[2]]) {
        tenant = domains[state.baseUrl.split('/')[2]].name;
      }
      console.log(tenant)
      return tenant
    },
    async getPublicSettings({ commit, state }, tenantName) {
      let tenant = 'default'
      if (tenantName) {
        tenant = tenantName
      }

      //Handle baseUrl initially when it is from build-parameters.json
      let baseUrl = null
      if (!state.baseUrl.includes("http")) {
        baseUrl = "https://" + state.baseUrl;
      } else {
        baseUrl = state.baseUrl;
      }

      console.log(baseUrl + '/appsettings/public/' + tenant)
      let settings = (await Vue.http.get(baseUrl + '/appsettings/public/' + tenant)).data || null
      commit('setState', { stateName: 'settings', stateValue: settings })
      return settings
    },

    //Nursegroups
    async getNursegroup({ state }, nursegroupId) {
      try {
        return (await Vue.http.get(state.baseUrl + '/nursegroups/' + nursegroupId)).data || null
      } catch (e) {
        console.log(e)
      }
    },

    //Messages
    async getMessages({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/messages/getByUserId/' + options.userId + '?pageSize=7&pageNumber=' + options.pageNumber)).data
    },
    async sendMessage({ commit, state }, messageThread) {
      messageThread.__v = state.message._v
      try {
        let _messageThread = (await Vue.http.put(state.baseUrl + '/messages/' + messageThread._id, messageThread)).data
        commit('setState', {
          stateName: 'message',
          stateValue: _messageThread
        })
        return _messageThread
      } catch (e) {
        console.log(e)
        throw e
      }
    },

    async makeAudioCall({ state }, options) {
      return await Vue.http.post(state.baseUrl + '/collaboration/pstn/_dial', {
        "from": options.from,
        "to": options.to
      })
    },
    async initiatePayment({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/transaction/initiate?gateway=' + options.gateway + '&appointment=' + options.appointmentId)).data
    },
    async payUingCredits({ state }, options) {
      try {
        let res = (await Vue.http.get(state.baseUrl + '/transaction/payuingcredits?appointment=' + options.appointmentId)).data
        return res
      } catch (error) {
        throw error
      }
    },
    async laborderPaymentUsingCredits({ state }, options) {
      try {
        let res = (await Vue.http.get(state.baseUrl + '/transaction/laborderPaymentUsingCredits?laborder=' + options.laborderId)).data
        return res
      } catch (error) {
        throw error
      }
    },
    async initiateCreditPointsPayment({ state }, options) {
      let response = (await Vue.http.post(state.baseUrl + '/transaction/creditPoints/initiate?gateway=' + options.gateway, options)).data
      return response
    },
    async initiateLabOrderPayment({ state }, options) {
      let response = (await Vue.http.get(state.baseUrl + '/transaction/laborder/initiate?gateway=' + options.gateway + '&laborder=' + options.laborderId)).data
      return response
    },
    async verifyPayment({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/transaction/verify?gateway=' + options.gateway, options.transaction)).data
    },
    async verifyCreditPointsPayment({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/transaction/creditPoints/verify?gateway=' + options.gateway, options.transaction)).data
    },
    async verifyLabOrderPayment({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/transaction/laborder/verify?gateway=' + options.gateway, options.transaction)).data
    },
    async signout({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/auth/app/signout', options)).data
    },
    async addNewDrug({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/drugs', options)).data
    },
    async getLatestVitals({ state }, patientId) {
      return (await Vue.http.get(state.baseUrl + '/vitalsdata/_latest/' + patientId)).data
    },
    async getCollaborationPtzControl({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/collaboration/ptzControl/' + options.appointment.endpoint + '/' + options.action + '/' + options.direction)).data
    },
    async getTenant({ state }, tenantId) {
      return (await Vue.http.get(state.baseUrl + '/tenants/' + tenantId)).data
    },
    async updateMessages({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/appointmentmessages', { message: options.newMesssage, appointmentId: options.appointmentId })).data
    },
    async updateIcuMessages({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/appointmentmessages/inpatient', { message: options.newMesssage, roomId: options.roomId })).data
    },
    async getIcuMessages({ state }, id) {
      try {
        let response = await Vue.http.get(state.baseUrl + '/appointmentmessages/byward/' + id)

        if (response && response.data) {
          return response.data
        }
        else {
          return null
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getIcuBedMessages({ state }, id) {
      try {
        let response = await Vue.http.get(state.baseUrl + '/appointmentmessages/byroomid/' + id)

        if (response && response.data) {
          return response.data
        }
        else {
          return null
        }
      } catch (e) {
        console.log(e)
      }
    },
    async clearUnreadMessagesCount({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/appointments/clear/unreadmessagescount/' + options.appointmentId, { userId: options.userId })).data
    },
    async uploadChatFileToMinio({ }, options) {
      try {

        //Converting to array buffer as ios native does not support blob
        let fileArrayBuffer = await options.file.arrayBuffer();

        return await Vue.http.put(options.url, fileArrayBuffer, {
          headers: { 'Content-Type': options.file.type }
        })
      } catch (e) {
        console.log(e)
      }
    },

    //coupon code
    async applyCouponForLabOrder({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/coupons/LabOrder/apply/' + options.couponCode + '?amount=' + options.amount + '&patientId=' + options.patientId + '&createdByUserId=' + options.userId)).data
    },
    async applyCoupon({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/coupons/apply/' + options.couponCode + '?apptId=' + options.appointmentId)).data
    },

    async removeCoupon({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/coupons/remove/' + options.couponCode + '?apptId=' + options.appointmentId)).data
    },
    //Patient
    async getHealthPackages({ commit, state }) {
      try {
        let healthPackages = (await Vue.http.get(state.baseUrl + '/healthpackages')).data || null
        commit('setState', { stateName: 'healthPackages', stateValue: healthPackages })
      } catch (e) {
        console.log(e)
      }
    },
    async startNewChat({ state }, message) {
      try {
        let chat = (await Vue.http.post(state.baseUrl + '/messages', message)).data || []
        return chat
      } catch (e) {
        console.log(e)
        throw (e)
      }
    },
    async getCurrentLocation({ commit }, options) {
      try {
        let currentLocation = (await Vue.http.get('https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + options.latitude + '&longitude=' + options.longitude + '&localityLanguage=' + options.locale)).data
        commit('setState', {
          stateName: 'myLocation',
          stateValue: currentLocation.locality
        })
      } catch (e) {
        console.log(e)
      }
    },
    async saveLocationUpdates({ state }, data) {
      try {
        return (await Vue.http({
          method: 'post',
          url: state.baseUrl + '/userlocations/app/track',
          data: data,
          headers: { 'Authorization': 'Basic ' + btoa(unescape(encodeURIComponent(state.settings.locationTracking.basicAuth.username + ':' + state.settings.locationTracking.basicAuth.password))) }
        })).data
      } catch (e) {
        console.log(e)
      }
    },
    //direct-telemed booking
    async getSpecialities({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/specialities/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
    },
    async getSpeciality({ state }, specialityId) {
      return (await Vue.http.get(state.baseUrl + '/specialities/' + specialityId)).data
    },
    async getAvailableSlots({ state }, query) {
      return (await Vue.http.post(state.baseUrl + '/slots/query', query)).data
    },
    async searchSpecialities({ state }, searchString) {
      return (await Vue.http.get(state.baseUrl + '/specialities/search/' + searchString)).data || []
    },
    async getSpecialityWithTenant({ state }, specialityId) {
      try {
        return (await Vue.http.get(state.baseUrl + '/directtelemedicine/speciality/_withtenant/' + specialityId)).data
      } catch (e) {
        console.log(e)
        throw (e)
      }
    },
    async getCountryCode({ }) {
      try {
        return ((await Vue.http.get('https://ip2c.org/s')).data).split(';')[1]
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async getLocationById({ state }, id) {
      try {
        return (await Vue.http.get(state.baseUrl + '/locations/' + id)).data
      } catch (e) {
        throw e
      }
    },

    //Feed
    async getFeedArticles({ commit, state }, options) {
      try {
        let response = (await Vue.http.get(state.baseUrl + '/blogarticles/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
        return response
      } catch (e) {
        throw e
      }
    },
    async getFeedArticlesByCategory({ commit, state }, options) {
      try {
        if (!options || !options.category) {
          throw new Error('Required options missing for get bolg articles by category api')
        }
        let response = (await Vue.http.get(state.baseUrl + '/blogarticles/bycategory/' + options.category + '/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
        return response
      } catch (e) {
        throw e
      }
    },
    async tesseractRecognize({ state }, file) {
      try {
        let formData = new FormData();
        formData.append('file', file.data, file.name);
        return (await Vue.http.post(state.baseUrl + '/tesseract/recognize', formData)).data
      } catch (e) {
        throw e
      }
    },

    async searchblogArticles({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/blogarticles/search/' + options.searchString + '/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data || []
    },

    async searchblogArticlesByCategory({ state }, options) {
      if (!options || !options.category) {
        throw new Error('Required options missing for get bolg articles by category api')
      }

      return (await Vue.http.get(state.baseUrl + '/blogarticles/search/bycategory/' + options.category + '/' + options.searchString + '/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data || []
    },

    //Nutirtion
    async getRecipeFromDishId({ state }, dishId) {
      return (await Vue.http.get(state.baseUrl + '/recipes/byDish/' + dishId)).data
    },
    async getRecipeImageFromDishId({ state }, foodIds) {
      return (await Vue.http.post(state.baseUrl + '/recipeImages/byDish/', { foodIds })).data
    },

    async getBreakfastRecipes({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/recipes/breakfast/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
    },

    async getLunchRecipes({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/recipes/lunch/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
    },

    async getDinnerRecipes({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/recipes/dinner/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
    },

    async filterRecipes({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/recipes/_filter', options)).data.data
    },

    // Nutirtion water tracker
    async setWaterConsumptionTarget({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/watertracker/_setwaterConsumptionTarget/' + options.userId, { waterConsumptionTarget: options.waterConsumptionTarget })).data
    },

    async addWaterIntake({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/watertracker/' + options.userId, {
        inTake: { amount: options.amount }
      }))
    },

    async getWaterConsumptionTraker({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/watertracker/bydate/' + options.userId, {
        date: options.date
      })).data
    },

    // issue tracker
    async createIssue({ state }, options) {
      return (await Vue.http.post(state.baseUrl + '/issues', options)).data
    },

    async getIssuesByUser({ state }, options) {
      return (await Vue.http.get(state.baseUrl + '/issues/byUserId/' + options.userId + '/?pageNumber=' + options.pageNumber + '&pageSize=' + options.pageSize)).data
    },

    async getIssue({ state }, issueId) {
      return (await Vue.http.get(state.baseUrl + '/issues/' + issueId)).data
    },

    //Er Encounters
    async startTriaging({ state }, appointmentId) {
      return (await Vue.http.get(state.baseUrl + '/emergencyroomencounters/' + appointmentId + '/_starttriage')).data
    },


    // nurse icu monitoring
    async getICUbedsForNurseEP({ state }, wardLocationId) {
      return (await Vue.http.get(state.baseUrl + '/locations/' + wardLocationId + '/children')).data
    },
    async getChildLocations({ state }, locationId) {
      return (await Vue.http.get(state.baseUrl + '/locations/' + locationId + '/children')).data
    },
    async getWardsForUserByNurseGroup({ state }, userId) {
      return (await Vue.http.get(state.baseUrl + '/locations/wards/byusernursegroup/' + userId)).data
    },

    async getPatientAddmissions({ state }, filter) {
      return (await Vue.http.post(state.baseUrl + '/patientadmissions/_filter', filter)).data
    }
  }
})
